import { BUILD_EMBED_TYPE, BUILD_ENV } from '@/utils/constants';
import { Device, DeviceType } from '@/utils/device-type';

export function getStandaloneMode(): boolean {
  return Boolean(
    ('standalone' in window.navigator && window.navigator.standalone) ||
      window.matchMedia('(display-mode: standalone)').matches,
  );
}

export function getDeviceIdentifier(): Device {
  if (BUILD_ENV === 'embedded') {
    if (getStandaloneMode()) return Device.BrandPWA;
    if (BUILD_EMBED_TYPE === 'embed-native') return Device.BrandNativeApp;
    return Device.BrandWeb;
  }
  return getStandaloneMode() ? Device.PWA : Device.Web;
}

export function getDeviceTypeIdentifier(): DeviceType {
  if (BUILD_ENV === 'embedded') {
    if (getStandaloneMode()) return DeviceType.PWA;
    if (BUILD_EMBED_TYPE === 'embed-native') return DeviceType.NativeApp;
    return DeviceType.Web;
  }
  return getStandaloneMode() ? DeviceType.PWA : DeviceType.Web;
}
